import { useEffect, useState } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";

export const useOAuthEnabledTools = () => {
  const [OAuthEnabledTools, setOAuthEnabledTools] = useState<string[]>([]);
  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getOAuthEnabledTools();
    promise
      .then((res: { oAuthEnabledTools: string }) => {
        if (res.oAuthEnabledTools) {
          setOAuthEnabledTools(res.oAuthEnabledTools.split(","));
        }
      })
      .catch((e) => console.log(e));
    return cancel;
  }, []);

  return OAuthEnabledTools;
};
